var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"app-link",attrs:{"href":_vm.linkResolver(_vm.link) || _vm.link.url,"target":_vm.link.target,"rel":_vm.link.target === '_blank' ? 'noopener noreferrer' : ''},on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }